module.exports = __webpack_public_path__ + "img/user_total.42fc4d8a.png";